var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 18.2004C19.2 16.654 17.7673 15.4004 16 15.4004C14.2327 15.4004 12.8 16.654 12.8 18.2004C12.8 19.7468 14.2327 21.0004 16 21.0004C17.7673 21.0004 19.2 22.254 19.2 23.8004C19.2 25.3468 17.7673 26.6004 16 26.6004C14.2327 26.6004 12.8 25.3468 12.8 23.8004",
    stroke: "#FABD3F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63245 13.1026C7.44914 10.6526 9.74197 9 12.3246 9H19.6754C22.258 9 24.5509 10.6526 25.3675 13.1026L29.3675 25.1026C30.6626 28.9878 27.7708 33 23.6754 33H8.32455C4.22921 33 1.33739 28.9878 2.63246 25.1026L6.63245 13.1026Z",
    stroke: "#FABD3F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3374 9L12.6626 9L10.4209 6.42873C8.22335 3.9082 10.787 0.140762 13.9953 1.17576L15.4798 1.65463C15.8177 1.76365 16.1823 1.76365 16.5203 1.65463L18.0047 1.17576C21.213 0.140763 23.7767 3.9082 21.5792 6.42873L19.3374 9Z",
    stroke: "#FABD3F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.6ec1ed8ca3483a17d3bbb46bd58b7ca2.svg";
export { ForwardRef as ReactComponent };